<app-navbar-one></app-navbar-one>

<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content">
                    <h2>Services</h2>
                    <!-- <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li>Services</li>
                    </ul> -->
                </div>
            </div>
        </div>
    </div>
</div>

<section class="services-section ptb-100 pt-70">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 d-flex">
                <div class="single-services-box">
                    <div class="icon">
                        <i class="flaticon-cellphone"></i>
                    </div>
                    <h3>Cross platform App Development</h3>
                    <p>We build superior multi-platform apps that provide close-to-native user experience </p>
                    <a routerLink="/services-details" class="read-btn">Read More</a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 d-flex">
                <div class="single-services-box">
                    <div class="icon bg-deb0fe">
                        <i class="flaticon-setting"></i>
                    </div>
                    <h3>Web Development</h3>
                    <p>Our supeior web apps can improve engagements, diminish costs, and do branding to generate business revenues</p>
                    <a routerLink="/services-details" class="read-btn">Read More</a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 d-flex">
                <div class="single-services-box">
                    <div class="icon bg-79e8e2">
                        <i class="flaticon-cellphone"></i>
                    </div>
                    <h3>Native App Development</h3>
                    <p>Create efficient and powerful apps with high value of users</p>
                    <a routerLink="/services-details" class="read-btn">Read More</a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 d-flex">
                <div class="single-services-box">
                    <div class="icon bg-fcc774">
                        <i class="flaticon-it"></i>
                    </div>
                    <h3>UI/UX Design Service</h3>
                    <p>Creative UI/UX designs with rich,fresh and simplified designs.</p>
                    <a routerLink="/services-details" class="read-btn">Read More</a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 d-flex">
                <div class="single-services-box">
                    <div class="icon bg-84b7fd">
                        <i class="flaticon-shopping-cart"></i>
                    </div>
                    <h3>E-commerce Development</h3>
                    <p>Purchase products as per convenient way to browse and compare.</p>
                    <a routerLink="/services-details" class="read-btn">Read More</a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 d-flex">
                <div class="single-services-box">
                    <div class="icon bg-fe929f">
                        <i class="flaticon-optimize"></i>
                    </div>
                    <h3>IT Consulting</h3>
                    <p>Lead your organization forward with our effective IT strategies and implement groundbreaking business solutions.</p>
                    <a routerLink="/services-details" class="read-btn">Read More</a>
                </div>
            </div>
            <!-- <div class="col-lg-12 col-md-12">
                <div class="pagination-area">
                    <a routerLink="/services-one" class="prev page-numbers"><i class="flaticon-left"></i></a>
                    <a routerLink="/services-one" class="page-numbers">1</a>
                    <span class="page-numbers current" aria-current="page">2</span>
                    <a routerLink="/services-one" class="page-numbers">3</a>
                    <a routerLink="/services-one" class="page-numbers">4</a>
                    <a routerLink="/services-one" class="next page-numbers"><i class="flaticon-right"></i></a>
                </div>
            </div> -->
        </div>
    </div>

    <div class="default-shape">
        <div class="shape-1"><img src="assets/img/shape/4.png" alt="image"></div>
        <div class="shape-2 rotateme"><img src="assets/img/shape/5.svg" alt="image"></div>
        <div class="shape-3"><img src="assets/img/shape/6.svg" alt="image"></div>
        <div class="shape-4"><img src="assets/img/shape/7.png" alt="image"></div>
        <div class="shape-5"><img src="assets/img/shape/8.png" alt="image"></div>
    </div>
</section>

